import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Space,
    Modal,
    DatePicker,
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

import { Review } from "../../../../types/Review";



interface FabricToGarmentsModalProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void; // Callback after successful submit
    initialValues?: {
        review_id?: number;
        review_name?: string;
    } | null;
    isEditMode?: boolean;
}

const FabricToGarmentsModal: React.FC<FabricToGarmentsModalProps> = ({
    visible,
    onCancel,
    onCreate,
    initialValues = null,
    isEditMode = false,
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);
    const [reviews, setReview] = useState<Review[]>([]);



    // Determine if submit button should be disabled based on form validation
    const isSubmitDisabled = () => {
        const errors = form.getFieldsError();
        return errors.some(({ errors }) => errors.length > 0);
    };


    const fetchreviews = () => {
    apiRequest({ method: 'get', url: 'reviews?status=1' })
        .then(data => setReview(data))
        .catch(() => showError('Failed to load Review groups'));
    };

    useEffect(() => {
    fetchreviews(); // initial load
    }, []);


    // Handle form submit
    const handleAddAh = async (values: any) => {
        try {
            const dataVal = {
                review_name: values.review_name,
                ...(initialValues?.review_id && { review_id: initialValues.review_id }),
            };
            const url = isEditMode
                ? 'edit-review'
                : 'add-review';

            const method = isEditMode ? 'put' : 'post';

            const data = await apiRequest({
                method,
                url,
                data: dataVal,
            });
            console.log(dataVal);

            onCreate(data); // Notify parent about success
            showSuccess(
                isEditMode ? 'Review updated successfully!' : 'Review created successfully!',
            );
            form.resetFields();

            // ✅ ✅ fetch updated list
            fetchreviews(); 

            if (isModalClose) {
                onCancel(); // Close modal only if Submit button was clicked (not Submit & Create New)
            }
        } catch (error) {
            showError(`Failed to ${isEditMode ? 'update' : 'create'} Review`);
        }
    };

    // // When modal opens or mode changes, set/reset form fields accordingly
    useEffect(() => {
        if (visible && isEditMode && initialValues) {
            form.setFieldsValue({
                review_name: initialValues.review_name,
            });
        } else if (visible) {
            form.resetFields();
        }
    }, [visible, isEditMode, initialValues, form]);

    return (
        <Modal
            title={isEditMode ? 'Edit Review' : 'Add New Review'}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="90%"
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddAh}
                autoComplete="off"
            >
                <Row gutter={16}>
                    
                    <Col span={12}>
                        <Form.Item
                            name="review_name"
                            className='px-8'
                            label={
                                <span>
                                    Review &nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 50 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the Review Name' },
                                { max: 50, message: 'Maximum 50 characters allowed' },
                            ]}
                            getValueFromEvent={(e) => {
                                let value = e.target.value;
                                // First letter ko capitalize karna
                                if (value.length > 0) {
                                    value = value.charAt(0).toUpperCase() + value.slice(1);
                                }
                                return value;
                            }}
                        >
                            <Input
                                showCount
                                maxLength={50}
                                placeholder="e.g., Review "
                            />
                        </Form.Item>
                    </Col>
                </Row>


                <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Space>
                        <Button onClick={onCancel}>Cancel</Button>
                        {!isEditMode && <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(false)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit & Create New Review
                        </Button>}
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(true)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default FabricToGarmentsModal;
